var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.25,
    width: 26.6,
    height: 28,
    rx: 6,
    fill: "#EB3E3E",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 9.45898C12.6545 9.45898 12.3747 9.7388 12.3747 10.084L12.3747 15.084C12.3747 15.4292 12.6545 15.709 12.9997 15.709C13.3449 15.709 13.6247 15.4292 13.6247 15.084L13.6247 10.084C13.6247 9.73881 13.3449 9.45898 12.9997 9.45898Z",
    fill: "#FF5353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 18.4173C12.5394 18.4173 12.1663 18.0442 12.1663 17.584C12.1663 17.1237 12.5394 16.7507 12.9997 16.7507C13.4599 16.7507 13.833 17.1237 13.833 17.584C13.833 18.0442 13.4599 18.4173 12.9997 18.4173Z",
    fill: "#FF5353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.958 14.2507C21.958 19.1982 17.9472 23.209 12.9997 23.209C8.05212 23.209 4.04134 19.1982 4.04134 14.2506C4.04134 9.3031 8.05212 5.29232 12.9997 5.29232C17.9472 5.29232 21.958 9.3031 21.958 14.2507ZM12.9997 21.959C17.2569 21.959 20.708 18.5078 20.708 14.2507C20.708 9.99346 17.2569 6.54232 12.9997 6.54232C8.74248 6.54232 5.29134 9.99345 5.29134 14.2506C5.29134 18.5078 8.74248 21.959 12.9997 21.959Z",
    fill: "#FF5353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRed);
export default __webpack_public_path__ + "static/media/info-red.15ae6a3d.svg";
export { ForwardRef as ReactComponent };